import React from 'react'

const SvgMinimize = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5 14.936a1 1 0 010-2h5.071a1 1 0 011 1v5.073a1 1 0 01-2 0v-4.073H5zm14.007-5.863a1 1 0 110 2h-5.071a1 1 0 01-1-1V5a1 1 0 012 0v4.073H19.007z'
    />
  </svg>
)

export default SvgMinimize
